import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import MassUpdateList from './MassUpdateList';

const MassUpdate = () => {
  return renderComponent(<MassUpdateList />);
};

export default MassUpdate;
